var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#01aa6d",
    fillOpacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.070886, 334.621912)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 133.324219 -279.796875 C 133.324219 -285.847656 131.238281 -288.769531 125.816406 -288.769531 L 83.667969 -288.769531 C 81.371094 -288.769531 77.824219 -287.097656 77.824219 -280.839844 L 77.824219 -73.027344 C 77.824219 -57.796875 70.105469 -45.695312 53.832031 -45.695312 C 44.234375 -45.695312 35.054688 -50.492188 29.003906 -56.753906 C 27.125 -58.839844 25.039062 -59.882812 22.953125 -59.882812 C 20.863281 -59.882812 18.777344 -58.839844 17.109375 -56.753906 L -2.085938 -32.550781 C -5.214844 -28.585938 -2.085938 -22.324219 -0.207031 -20.03125 C 13.769531 -3.128906 35.679688 4.589844 56.753906 4.589844 C 98.273438 4.589844 133.324219 -23.996094 133.324219 -69.898438 Z M 133.324219 -279.796875 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#01aa6d",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.185944, 315.736978)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 133.324219 -279.796875 C 133.324219 -285.847656 131.238281 -288.769531 125.816406 -288.769531 L 83.667969 -288.769531 C 81.371094 -288.769531 77.824219 -287.097656 77.824219 -280.839844 L 77.824219 -73.027344 C 77.824219 -57.796875 70.105469 -45.695312 53.832031 -45.695312 C 44.234375 -45.695312 35.054688 -50.492188 29.003906 -56.753906 C 27.125 -58.839844 25.039062 -59.882812 22.953125 -59.882812 C 20.863281 -59.882812 18.777344 -58.839844 17.109375 -56.753906 L -2.085938 -32.550781 C -5.214844 -28.585938 -2.085938 -22.324219 -0.207031 -20.03125 C 13.769531 -3.128906 35.679688 4.589844 56.753906 4.589844 C 98.273438 4.589844 133.324219 -23.996094 133.324219 -69.898438 Z M 133.324219 -279.796875 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.1bbba9c9049fd63dfb4582aec5c81cbc.svg";
export { ForwardRef as ReactComponent };